import { ToolType } from "api/resources/aiTools/types"
import clsx from "clsx"
import Paper from "features/AItools/components/Paper"

import AIToolsError from "../../helpers/AIToolsError"
import { InputDisplay } from "../../helpers/InputDisplay"
import { SubjectiveAssessmentReturnType } from "../../SubjectiveAssessmentGenerator/useSubjectiveAssessment"
import OutputToolbar from "../OutputToolbar"
import ToolOutput from "../ToolOutput"
import styles from "./SubjectiveAssessmentOutput.module.css"

const SubjectiveAssessmentOutput = (
  props: Pick<
    SubjectiveAssessmentReturnType,
    | "output"
    | "isLoading"
    | "isPositiveResponse"
    | "currentResponseId"
    | "setCurrentResponseId"
    | "regenerateResponse"
    | "overviewData"
    | "responseIds"
    | "userVote"
    | "onBack"
    | "stream"
    | "streamPro"
    | "isError"
  >
) => {
  const {
    output,
    overviewData,
    responseIds,
    currentResponseId,
    isPositiveResponse,
    setCurrentResponseId,
    userVote,
    regenerateResponse,
    isLoading,
    onBack,
    isError,
  } = props
  return (
    <div className="mb-4 flex flex-col gap-3">
      {overviewData && !isError && <InputDisplay data={{ ...overviewData }} />}
      {isError ? (
        <AIToolsError onClick={onBack} />
      ) : (
        <Paper
          className="p-0"
          endSlot={
            isLoading ? undefined : (
              <OutputToolbar
                toolType={
                  overviewData?.isPro
                    ? ToolType.subjectiveAssessmentPro
                    : ToolType.subjectiveAssessment
                }
                responseIds={responseIds}
                currentResponseId={currentResponseId}
                copyText={output}
                isPositiveResponse={isPositiveResponse}
                onResponseIdChange={responseId => {
                  setCurrentResponseId(responseId)
                }}
                onUserReaction={reaction => {
                  userVote.mutate({ reaction, isPro: overviewData!.isPro })
                }}
                onRegenerate={reason => {
                  regenerateResponse.mutate({
                    reason,

                    isPro: overviewData!.isPro,
                  })
                }}
              />
            )
          }
        >
          <div className={clsx("overflow-x-auto", styles.tableContainer)}>
            <ToolOutput
              isLoading={isLoading}
              onClick={() => {
                if (responseIds) {
                  setCurrentResponseId(
                    responseIds?.length > 1
                      ? responseIds[responseIds?.length - 1]
                      : responseIds[0]
                  )
                }
              }}
            >
              {output}
            </ToolOutput>
          </div>
        </Paper>
      )}
    </div>
  )
}

export default SubjectiveAssessmentOutput
